// extracted by mini-css-extract-plugin
export default {"text-body-1":"Banner_text-body-1__RfjqJ","text-body-3":"Banner_text-body-3__DFy07","banner":"Banner_banner__iPZSf","upDown":"Banner_upDown__vJzlv"};